import { render, staticRenderFns } from "./PublishingScheduleDialog.vue?vue&type=template&id=3bc3c8d8&scoped=true&"
import script from "./PublishingScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./PublishingScheduleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3c8d8",
  null
  
)

export default component.exports